const reportNameMap = {
    teamsummary: 'summary',
    record: 'summary',
    faceoffs: 'faceoffwins',
};

const sortingMap = {
    faceoffsWon: 'totalFaceoffWins',
    savePctg: 'savePct',
    ppPctg: 'powerPlayPct',
    pkPctg: 'penaltyKillPct',
    faceoffWinPctg: 'faceoffWinPct',
    pointPctg: 'pointPct',
};

const updateMobileParams = (props) => {
    const location = { ...props.location };

    if (location.pathname.indexOf('/mobile') !== -1) {
        let oldReportPath = 'player';
        let reportCategory = 'skaters';
        if (location.search.indexOf('pos=G') !== -1) {
            reportCategory = 'goalies';
        }
        if (location.pathname.indexOf('team') !== -1) {
            oldReportPath = 'team';
            reportCategory = 'teams';
        }

        const replaceQueryParam = (param, paramMap) => {
            Object.keys(paramMap).forEach((key) => {
                const value = paramMap[key];
                if (location.search.indexOf(`${param}=${key}`) !== -1) {
                    location.search = location.search.replace(`${param}=${key}`, `${param}=${value}`);
                }
            });
        };

        replaceQueryParam('report', reportNameMap);
        replaceQueryParam('sort', sortingMap);

        // Update location, used for routing
        location.pathname = location.pathname.replace(`/mobile/${oldReportPath}`, `/${reportCategory}`);

        // Update URL of report (Used for getting correct Report Category)
        location.mobilePath = `${reportCategory}${location.search}`;
    }

    return location;
};

export default updateMobileParams;
